import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_290: DocMigration = {
  maxSchemaVersion: "0.0.290",
  description: "Rename SettingsSetBehaviorType instances",
  apply(json: any): any {
    for (const id in json.settingsSets) {
      const settingsSet = json.settingsSets[id];

      if (!settingsSet.type || settingsSet.type === "PUSH") {
        settingsSet.type = "GLOBAL";
      } else if (settingsSet.type === "PULL") {
        settingsSet.type = "TARGETED";
      }

      json.settingsSets[id] = settingsSet;
    }

    return json;
  },
};

export default migration_0_0_290;
